export class AppConsts {
    static readonly tenancyNamePlaceHolderInUrl = "{TENANCY_NAME}";

    static remoteServiceBaseUrl: string;
    static remoteServiceBaseUrlFormat: string;
    static appBaseUrl: string;
    static appBaseUrlFormat: string;
    static recaptchaSiteKey: string;
    static subscriptionExpireNootifyDayCount: number;

    static localeMappings: any = [];

    static readonly userManagement = {
        defaultAdminUserName: "admin",
    };

    static readonly localization = {
        defaultLocalizationSourceName: "pos",
    };

    static readonly authorization = {
        encrptedAuthTokenName: "enc_auth_token",
    };

    static readonly grid = {
        defaultPageSize: 10,
    };

    static readonly appSessionItems = {
        tenantInfo: "TENANT_INFO",
        isParentTenantManage: "IS_PARENT_TENANT_MANAGE",
        storeId:"QRMENA_STOREID",
        pinCode:"PINCODE",
        tableId:"TABLEID",
        userId:"USERID"
    };
    static readonly PRIMARY_CATEGORY: string = "PrimaryCategories";
    static readonly SECONDRY_CATEGTORY: string = "SecondaryCategories";
    static readonly PRODUCT_CATEGORY: string = "ProductCategories";
    static readonly SALE: string = "Sale";
    static readonly PURCHASE_INVENTORY: string = "purchaseInventory";
    static readonly PURCHASE_RETURN_INVENTORY: string =
        "purchaseInventoryRefund";
    static readonly INVENTORY_ORDER_DOCNUMBER: string =
        "InventoryOrderDocumentNumber";

    static readonly INVENTORY_RECIVE_DOCNUMBER: string =
        "InventoryReceiveDocumentNumber";
    static readonly INVENTORY_RAW_WAST_DOCNUMBER: string =
        "InventoryRawWasteDocumentNumber";
    static readonly INVENTORY_MENUITEM_WAST_DOCNUMBER: string =
        "InventoryMenuItemWasteDocumentNumber";
    static readonly INVENTORY_STOCK_ADJUSTMENT_DOCNUMBER: string =
        "InventoryStockAdjustmentDocumentNumber";
    static readonly INVENTORY_TRANSFER_DOCNUMBER: string =
        "InventoryTransferDocumentNumber";
    static readonly INVENTORY_BATCHRECIPE_DOCNUMBER: string =
        "BatchRecipeDocumentNumber";
    static readonly INVENTORY_STOCK_OPENNING_ADJUSTMENT_DOCNUMBER =
        "InventoryStockOpennigAdjustmentDocumentNumber";
}



// WEBPACK FOOTER //
// ./src/shared/AppConsts.ts